import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  lt: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    },
  },
}

const numberFormats = {
  en: {
    currency: {
      style: 'currency',
      currency: 'EUR',
    },
  },
  lt: {
    currency: {
      style: 'currency',
      currency: 'EUR',
    },
  },
}

export default new VueI18n({
  locale: window.localStorage.getItem('language') || process.env.VUE_APP_I18N_LOCALE || 'lt',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'lt',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  formatFallbackMessages: true,
  dateTimeFormats,
  numberFormats,
  messages: loadLocaleMessages(),
})
